<template>    
  <v-card style="background-color:antiquewhite; font-weight:500">    
    <v-card-title class="headline brown darken-4" style="color:white">Stats Settings</v-card-title>
    <v-row>
      <v-col cols="4" md="4" sm="12">
        <div v-for="stat in statNames" v-bind:key="stat">
          <div class="my-list-item">
            <v-row class="ml-0">
              <v-col cols="3" md="3" sm="3" style="align-self:center">
                {{stat[0].toUpperCase() + stat.substr(1)}}:
              </v-col>
              <v-col cols="7" md="7" sm="7" style="display:inline-flex">
                <v-text-field class="filled-list-item" style="width:104px" persistent-hint hint="Total" disabled readonly single-line :value="(parseInt(characterSheet.abilityScore[stat]) + parseInt(characterSheet.tempModifiers[stat])) + ' (+' + Math.floor(((parseInt(characterSheet.abilityScore[stat]) + parseInt(characterSheet.tempModifiers[stat]))-10)/2) +')'" ></v-text-field>
                <v-text-field class="filled-list-item" persistent-hint hint="Base" single-line disabled readonly :value="characterSheet.abilityScore[stat]" ></v-text-field>
                <v-text-field class="my-list-input" persistent-hint hint="Temp Mod" single-line @focus="$event.target.select()" v-model="characterSheet.tempModifiers[stat]" :rules="[rules.number]"></v-text-field>
              </v-col>                 
            </v-row>
          </div> 
        </div>
      </v-col>
      <v-col cols="4" md="4" sm="12">
        <div class="my-list-item">
         <v-col cols="3" style="align-self:center; padding-left:0px">
            Spell Points:
         </v-col>
         <v-col cols="3" style="display:inline-flex">
          <v-text-field dense class="my-list-input" style="width:36px" persistent-hint hint="Temp Mod" @focus="$event.target.select()" v-model="characterSheet.tempModifiers.spellPoints" :rules="[rules.number]"></v-text-field>
         </v-col>
        </div>
        <div class="my-list-item">
         <v-col cols="3" style="align-self:center; padding-left:0px">
            Negative Levels:
         </v-col>
         <v-col cols="3" style="display:inline-flex">
          <v-text-field dense class="my-list-input" style="width:36px" persistent-hint hint="Temp Mod" @focus="$event.target.select()" v-model="characterSheet.tempModifiers.negativeLevels" :rules="[rules.number]"></v-text-field>
         </v-col>
      </div>
      <div class="my-list-item">
         <v-col cols="3" style="align-self:center; padding-left:0px">
            Save Bonus:
         </v-col>
         <v-col cols="3" style="display:inline-flex">
          <v-text-field dense class="my-list-input" style="width:36px" persistent-hint hint="Temp Mod" @focus="$event.target.select()" v-model="characterSheet.tempModifiers.saves" :rules="[rules.number]"></v-text-field>
         </v-col>
      </div>
      <div v-for="save in saves" v-bind:key="save.name">
        <div class="my-list-item">
          <v-row>
            <v-col cols="3" style="align-self:center">
              {{save.name[0].toUpperCase() + save.name.substr(1)}} Save:
            </v-col>
            <v-col cols="8" style="display:inline-flex">
              <v-text-field class="filled-list-item" persistent-hint hint="Total" disabled readonly single-line :value="parseInt(characterSheet.misc[save.name]) + parseInt(tempModifier(save.stat)) + parseInt(characterSheet.tempModifiers[save.name]) + parseInt(characterSheet.tempModifiers.saves) - Math.abs(parseInt(characterSheet.tempModifiers.negativeLevels))" ></v-text-field>
              <v-text-field class="my-list-input" persistent-hint hint="Temp Mod" @focus="$event.target.select()" single-line v-model="characterSheet.tempModifiers[save.name]" :rules="[rules.number]"></v-text-field>
              <v-text-field class="filled-list-item" persistent-hint hint="Base Save" single-line disabled readonly :value="characterSheet.misc[save.name]" ></v-text-field>
              <v-text-field class="filled-list-item" persistent-hint hint="Stat Mod" single-line disabled readonly :value="tempModifier(save.stat)"></v-text-field>
              <v-text-field class="filled-list-item" persistent-hint hint="Misc" single-line disabled readonly :value="(Math.abs(parseInt(characterSheet.tempModifiers.negativeLevels)) * -1) + parseInt(characterSheet.tempModifiers.saves)"></v-text-field>
            </v-col>     
          </v-row>
        </div> 
      </div>
      <div class="my-list-item">
         <v-col cols="3" style="align-self:center; padding-left:0px">
            Stat For CMB:
            <br/>Size:
         </v-col>
         <v-col cols="4" style="align-self:center">
           <v-spacer></v-spacer>
            <v-combobox style="width:150px" v-model="statsForAbilities.cmb" @focus="$event.target.select()" :items="statNames" hide-details outlined dense></v-combobox>
            <v-spacer></v-spacer>
            <div style="display:flex; align-items:center;">
              <v-icon @click="sizeChange('down')">mdi-arrow-left</v-icon>
              <v-text-field style="width:150px" v-model="statsForAbilities.size"></v-text-field>
              <v-icon @click="sizeChange('up')">mdi-arrow-right</v-icon>
            </div>
         </v-col>
      </div>
      <div class="my-list-item">
        <v-row>
          <v-col cols="3" style="align-self:center">
            CMB Modifier:
          </v-col>
          <v-col cols="9" style="display:inline-flex">
            <v-text-field class="filled-list-item" persistent-hint hint="Total" disabled readonly single-line :value="cmbTotal" ></v-text-field>
            <v-text-field class="my-list-input" persistent-hint hint="Temp Mod" @focus="$event.target.select()" single-line v-model="characterSheet.tempModifiers.cmb" :rules="[rules.number]"></v-text-field>
            <v-text-field class="filled-list-item" persistent-hint hint="Stats Mods" disabled readonly single-line :value="tempModifier(statsForAbilities.cmb) + (statsForAbilities.lvlForBab ? parseInt(characterSheet.misc.level) : parseInt(characterSheet.misc.BAB))" ></v-text-field>
            <v-text-field class="filled-list-item" persistent-hint hint="Misc" disabled readonly single-line :value="Math.abs(parseInt(characterSheet.tempModifiers.negativeLevels)) * -1" ></v-text-field>
          </v-col>    
        </v-row>
      </div>
      <div class="my-list-item">
        <v-row>
          <v-col cols="3" style="align-self:center">
            CMD Modifier:
            <v-tooltip right style="margin-right:4px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">help_outline</v-icon>
              </template>
              <span>CMD modifier includes: <br/>-Strength modifier <br/>-Your AC ability score set in armor modifier settings <br/>-BAB or level if "Use Level For BAB" is checked off in weapon modifier settings<br/><br/> Misc includes: deflection modifier to ac, dodge modifier to ac, and negative levels</span>
            </v-tooltip>
          </v-col>
          <v-col cols="9" style="display:inline-flex">
            <v-text-field class="filled-list-item" persistent-hint hint="Total" disabled readonly single-line :value="cmdTotal" ></v-text-field>
            <v-text-field class="my-list-input" persistent-hint hint="Temp Mod" @focus="$event.target.select()" single-line v-model="characterSheet.tempModifiers.cmd" :rules="[rules.number]"></v-text-field>            
            <v-text-field class="filled-list-item" persistent-hint hint="Stats Mods" disabled readonly single-line :value="tempModifier('strength') + tempModifier(statsForAbilities.ac.abilityMod) + (statsForAbilities.lvlForBab ? parseInt(characterSheet.misc.level) : parseInt(characterSheet.misc.BAB))" ></v-text-field>
            <v-text-field class="filled-list-item" persistent-hint hint="Misc" disabled readonly single-line :value="parseInt(statsForAbilities.ac.deflection) + parseInt(statsForAbilities.ac.dodge) - Math.abs(parseInt(characterSheet.tempModifiers.negativeLevels))" ></v-text-field>
            <span style="align-self:center">+10</span>
          </v-col>
        </v-row>
      </div>
      </v-col>
      <v-col cols="4" md="4" sm="12">
        <v-row style="align-items:center">
          <v-col cols="3">
            Armor Check Penalty: 
          </v-col>
        <v-col cols="2" style="display:inline-flex">
          <v-text-field class="my-list-input" persistent-hint @focus="$event.target.select()" single-line v-model="characterSheet.tempModifiers.armorCheckPenalty" :rules="[rules.number]"></v-text-field>
        </v-col>
        </v-row>
        <div v-for="skill in characterSkills" v-bind:key="skill">
          <div class="my-list-item">
            <v-row>
              <v-col cols="3" style="align-self:center">
                {{capitalize(skill)}}:
              </v-col>
              <v-col cols="9" style="display:inline-flex">
                <v-text-field class="filled-list-item" persistent-hint hint="Total" disabled readonly single-line :value="parseInt(characterSheet.skills[skill]) + parseInt(skillModifier(skill)) + parseInt(characterSheet.tempModifiers[skill]) - parseInt(armorCheck(skill)) - Math.abs(parseInt(characterSheet.tempModifiers.negativeLevels))" ></v-text-field>
                <v-text-field class="my-list-input" persistent-hint hint="Temp Mod" @focus="$event.target.select()" single-line v-model="characterSheet.tempModifiers[skill]" :rules="[rules.number]"></v-text-field>
                <v-text-field class="filled-list-item" persistent-hint hint="Base" single-line disabled readonly :value="characterSheet.skills[skill]" ></v-text-field>
                <v-text-field class="filled-list-item" persistent-hint hint="Stat Mod" single-line disabled readonly :value="skillModifier(skill)"></v-text-field>
                <v-text-field class="filled-list-item" persistent-hint hint="Misc" single-line disabled readonly :value="(parseInt(armorCheck(skill)) * -1) - Math.abs(parseInt(characterSheet.tempModifiers.negativeLevels))"></v-text-field>
              </v-col>             
            </v-row>
          </div> 
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {skills} from "./data"
import { sizeMods } from "./data"
export default {
   props: {
     characterSheet:{},
     statsForAbilities:{}
  },
  data() {
    return {
      rules: {
          number: value => {            
            return (parseInt(value) || value==0) || 'Must Be a Number'
          }
      },
      textLength:1,
      statNames:['strength',"dexterity","constitution","intelligence","wisdom","charisma"],
      saves:[
        {name:'fortitude', stat:"constitution"},
        {name:"reflex", stat:"dexterity"},
        {name:"will", stat:"wisdom"}
      ]
    }
  },
  computed:{
    characterSkills(){
       return Object.keys(this.characterSheet.skills);
    },
    cmbTotal(){
      let bab = parseInt(this.statsForAbilities.lvlForBab) ? parseInt(this.characterSheet.misc.level) : parseInt(this.characterSheet.misc.BAB)
      return this.tempModifier(this.statsForAbilities.cmb) + bab + parseInt(this.characterSheet.tempModifiers.cmb) - Math.abs(parseInt(this.characterSheet.tempModifiers.negativeLevels))
    },
    cmdTotal(){    
      return parseInt(this.tempModifier("strength")) + parseInt(this.tempModifier(this.statsForAbilities.ac.abilityMod)) + parseInt(this.statsForAbilities.lvlForBab) ? parseInt(this.characterSheet.misc.level) : parseInt(this.characterSheet.misc.BAB)  + 10 + parseInt(this.characterSheet.tempModifiers.cmd) + parseInt(this.statsForAbilities.ac.deflection) + parseInt(this.statsForAbilities.ac.dodge) - Math.abs(parseInt(this.characterSheet.tempModifiers.negativeLevels))
    }    
  },
  methods:{
    modifier(stat) {
      let score = this.characterSheet.abilityScore[stat];
      let modifier = Math.floor((score - 10) / 2);
      return modifier;
    },
    tempModifier(stat){
      let score = this.characterSheet.modifiedStats[stat];
      let modifier = Math.floor((score - 10) / 2);
      return modifier;
    },
    skillModifier(stat){
     let ability = skills.find(skill => skill.skill == stat).abilityMod
      if(ability.length > 1){
        let ability1 = this.tempModifier(ability[0])
        let ability2 = this.tempModifier(ability[1])
        ability = ability1 > ability2 ? ability[0] : ability[1]
      }else{
        ability = ability[0]
      }
      if(ability == "intelligence"){
        if(stat.includes("know")){
          let tempMod = this.tempModifier(ability) 
          if(tempMod > 0) return tempMod * 2
        }
      }
      return this.tempModifier(ability)
    },    
    armorCheck(stat){
      let ability = skills.find(skill => skill.skill == stat).abilityMod
      if(ability.length > 1){
        let ability1 = this.tempModifier(ability[0])
        let ability2 = this.tempModifier(ability[1])
        ability = ability1 > ability2 ? ability[0] : ability[1]
      }else{
        ability = ability[0]
      }
      if(ability == "strength" || ability == "dexterity"){        
        return Math.abs(parseInt(this.characterSheet.tempModifiers.armorCheckPenalty))
      }else{
        return 0
      }    
    },
    select: function(event){
      event.target.setSelectionRange(0, this.textLength)
    },
    capitalize(str){
      for(let x = 0; x < str.length; x++){
        if(str[x].toUpperCase() == str[x]){
          str = str.substring(0,x) + " " + str.substring(x,str.length)
          break;
        }
      }            
      let newStr = str[0].toUpperCase() + str.substring(1)
      return newStr
    },
    sizeChange(direction){
      let sizes = Object.keys(sizeMods)
      let currentIndex = sizes.indexOf(this.statsForAbilities.size)
      if(direction == "up"){
        this.statsForAbilities.size = sizes[currentIndex + 1]
      }else{
        this.statsForAbilities.size = sizes[currentIndex - 1]
      }
    }
  }
}
</script>
<style>
  .my-list-item {
    display:inline-flex;
    align-items: baseline;
    display:flex;    
  }
  .my-list-input {
    width:36px;
    margin-left: 4px;
    text-align-last: center;
    padding-left: 16px;
    padding-right: 16px;
  }
  .filled-list-item{
    text-align-last: center;
    width:36px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .v-messages__message{
    text-align:center;
  }
  .theme--light.v-text-field.v-input--is-disabled{
    color: #000 !important;
  }
  .theme--light.v-text-field.v-input--is-disabled .v-input__slot::before{
    color: #000 !important;
  }
  .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: #000 !important;
  }
</style>